import React, { Component } from 'react'
import classNames from 'classnames';

class Oils extends Component {

  render() {
    let pigments = {
        ...this.props.huePigments,
        ...this.props.neutralPigments
    };

    return (
        <div className="mt-10 h-full">
            <div className="flex items-center">
                <div>
                    <h3 className="font-bold">Oils</h3>
                </div>
                <div>
                    <div className={classNames({ hidden: !this.props.loading}, 'ml-2', 'overflow-hidden', 'loader', 'ease-linear', 'rounded-full', 'border-4', 'border-t-4', 'border-gray-300', 'h-4', 'w-4')}></div>
                </div>
            </div>
            <div className="text-sm text-gray-500">Oils to mix stored pigment</div>
            <ul className="mt-3 grid grid-cols-1 gap-5">
                {
                    Object.entries(pigments).map((pigment, index) => 
                        <li key={index} className="col-span-1 flex items-center bg-white border border-gray-200 rounded-md shadow-sm overflow-hidden">
                            <div className={classNames([{'text-white': pigment[0] !== 'White'}, {'text-black': pigment[0] === 'White'}, 'uppercase', 'flex-shrink-0', 'flex', 'items-center', 'justify-center', 'w-16', 'h-16', 'text-center', 'text-sm', 'leading-5', 'font-medium'])}
                                style={{backgroundColor: pigment[1]}}>
                                {pigment[0].substring(0, 2)}
                            </div>
                            <div className="flex-1 px-4 py-2 truncate">
                                <div className="text-gray-900 text-sm leading-5 font-medium hover:text-gray-600 transition ease-in-out duration-150">{pigment[0]}</div>
                                <button onClick={() => this.props.addToCart(pigment[0])} className="text-sm leading-5 text-gray-500">Add to Cart</button>
                            </div>
                        </li>
                    )
                }
            </ul>
        </div>
    );
  }
}

export default Oils;
